/* eslint-disable max-len */
import { Box } from '@mui/material';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import { ReactComponent as Calendar_Icon } from '../../../assets/icons/base/calendar.svg';

export const DateTimeRangeWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  background: theme.palette.base.background,
  flexDirection: 'column',
  alignItems: 'center',
  '.date-range-picker-wrapper': {
    width: 'max-content',
  },
  '#menu- > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiMenu-paper.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper > ul': {
    paddingBottom: '16px',
    paddingRight: '16px !important',
  },
  'ul.MuiList-root.MuiList-padding': {
    padding: '1rem',
    borderRight: 'solid 1px',
    borderColor: theme.palette.grey[200],
    background: theme.palette.base.background,
    paddingBottom: '100px',
  },
  ' .MuiBox-root .MuiPaper-elevation > .MuiGrid-wrap-xs-nowrap > .MuiGrid-root':
    {
      background: theme.palette.base.background,
    },
  'ul.MuiList-root.MuiList-padding > .MuiListItem-button': {
    color: theme.palette.mode !== 'light' && theme.palette.grey[400],
    borderRadius: '6px',
    width: '160px',
  },
  '.MuiBox-root > div > div > div:nth-child(3) > div.MuiGrid-root.MuiGrid-container:first-child':
    {
      display: 'none',
    },
  '.MuiGrid-root.MuiGrid-container.MuiGrid-item.MuiGrid-direction-xs-column > .MuiGrid-root.MuiGrid-container':
    {
      padding: '2px 0',
    },
  '.MuiGrid-root.MuiGrid-container.MuiGrid-item.MuiGrid-direction-xs-column > .MuiGrid-root.MuiGrid-container > div:first-child':
    {
      borderBottomLeftRadius: '50%',
      borderTopLeftRadius: '50%',
    },
  '.MuiGrid-root.MuiGrid-container.MuiGrid-item.MuiGrid-direction-xs-column > .MuiGrid-root.MuiGrid-container > div:last-child':
    {
      borderBottomRightRadius: '50%',
      borderTopRightRadius: '50%',
    },
  button: {
    borderRadius: '50%',
  },
  'button p': {
    color: theme.palette.mode !== 'light' && theme.palette.grey[400],
  },
  '.date-range-picker-wrapper.MuiBox-root > div > div > div:nth-child(3) > div.MuiGrid-root.MuiGrid-container.MuiGrid-wrap-xs-nowrap > div:nth-child(odd)':
    {
      background: theme.palette.base.background,
      borderBottom: 'solid 1px',
      borderColor: theme.palette.grey[300],
    },
  '.MuiBox-root > .MuiPaper-root.MuiPaper-elevation': {
    boxShadow: '0px 0px 0px grey',
  },
  width: 'max-content',
  '> * > .MuiBox-root': {
    position: 'relative',
    height: '100%',
    width: '100%',
  },
  hr: {
    display: 'none',
  },
  '.MuiBox-root > div > div > div:nth-child(3) > .MuiGrid-root.MuiGrid-container > hr':
    {
      display: 'inherit',
    },
}));

export const AMPMSelectWrapper = styled.span(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '8px 14px',
  gap: '8px',
  width: '98x',
  height: '40px',
  textAlign: 'center',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  color: theme.palette.grey[500],
  border: `1px solid ${theme.palette.grey[300]}`,
  boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
  borderRadius: '8px',
}));

export const StyledTimePicker = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.grey[500]};
  background-color: ${({ theme }) => theme.palette.base.background};
  width: 25px;
  margin-left: 5px;
`;

export const StyledTimePickerWrapper = styled.span`
  color: ${({ theme }) => theme.palette.grey[500]};
  display: flex;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.grey[300]};
  padding: 6px 14px;
  justify-content: center;
  align-items: center;
`;

export const DateRangeInput = styled(TextField)(({ theme }) => ({
  caretColor: 'transparent',
  borderRadius: '8px',
  width: '100%',
  background: theme.palette.base.background,
  input: {
    width: 'calc(100% - 32px)',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '11px',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  '.MuiInputBase-formControl': {
    borderRadius: '8px',
  },
}));

export const DateRangeInputWrapper = styled.span(({ theme }) => ({
  position: 'relative',
  cursor: 'pointer',
  background: theme.palette.primary[0],
}));

export const DateRangeWrapper = styled.span(({ theme }) => ({
  position: 'relative',
  background: theme.palette.primary[0],
}));

export const CalendarIcon = styled(Calendar_Icon)(({ theme }) => ({
  position: 'absolute',
  top: '6px',
  right: '12px',
  height: '30px',
  padding: '3px',
  width: '30px',
  background: theme.palette.base.background,
}));

export const TimePickerWrapper = styled.span(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  padding: '0.5rem 1rem',
  background: theme.palette.primary[0],
  position: 'absolute',
  zIndex: 1,
  left: '192px',
  bottom: 'calc(15% - 4px)',
  width: 'calc(100% - 192px)',
}));

export const FooterWrapper = styled.span(({ theme }) => ({
  display: 'flex',
  width: '100%',
  padding: '1rem 3rem',
  gap: '1rem',
  background: theme.palette.grey[100],
}));

export const ModalWrapper = styled.span(({ theme }) => ({
  position: 'absolute',
  boxShadow: '0px 0px 7px -4px black',
  zIndex: 1,
  borderRadius: '8px',
  left: '-40%',
  top: '3rem',
  background: theme.palette.base.background,
  '@media (max-width: 1199px)': {
    left: 'auto',
    right: 0,
  },
}));
